/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Necessary overrides for Smart Collection Pro's native Shadow DOM styling
  function injectBreadcrumbStyles() {
    const selectors = ['smart-collection-pro-breadcrumb', 'scp-product-breadcrumb'];
    let injectedCount = 0;
    
    selectors.forEach(selector => {
      const shadowHost = document.querySelector(selector);
      if (shadowHost && shadowHost.shadowRoot) {
        if (!shadowHost.shadowRoot.querySelector('style[data-breadcrumb-styles]')) {
          const style = document.createElement('style');
          style.setAttribute('data-breadcrumb-styles', '');
          style.textContent = `
            nav li {
              display: flex;
              align-items: baseline;

              @media screen and (width < 750px) {
                font-size: 0.875rem;
              }

              a {
                text-decoration: none !important;

                @media screen and (width < 750px) {
                  font-size: 0.875rem;
                }

                &:hover {
                  @media screen and (hover: hover) {
                    text-decoration: underline !important;
                  }
                }
              }

              &[data-bc-root] {
                @media screen and (width < 750px) {
                  a {
                    display: inline-block;
                    width: 13px;
                    height: 13px;
                    background-image: url("data:image/svg+xml,%0A%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 55 55' %3E%3Cpolygon fill='none' stroke='%2363666a' stroke-width='3' points='27.2,2.8 5.1,22.7 5.1,52.3 21.9,52.3 21.9,38.2 27.1,38.2 27.2,38.2 32.4,38.2 32.4,52.3 49.3,52.3 49.3,22.7 '/%3E%3C/svg%3E%0A");
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                    color: transparent;
                    overflow: hidden;
                    white-space: nowrap;
                  }
                }
              }
            }
          `;
          shadowHost.shadowRoot.appendChild(style);
          injectedCount++;
        }
      }
    });
    
    return injectedCount > 0;
  }

  if (!injectBreadcrumbStyles()) {
    const smartCollectionObserver = new MutationObserver(() => {
      if (injectBreadcrumbStyles()) {
        smartCollectionObserver.disconnect();
      }
    });
    smartCollectionObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Re-initialize Swym wishlist buttons for dynamically loaded Nosto carousels
  function reinitializeSwymForNosto() {
    if (!window._swat) return;
    
    const unloadedButtons = document.querySelectorAll('.swym-button:not(.swym-loaded)');
    if (unloadedButtons.length === 0) return;
    
    let wishlistProductIds = new Set();
    
    try {
      const swymProducts = localStorage.getItem('swym-products');
      if (swymProducts) {
        const productsData = JSON.parse(swymProducts);
        const products = productsData.all || productsData;
        
        if (Array.isArray(products)) {
          products.forEach(item => {
            if (item.empi) wishlistProductIds.add(String(item.empi));
          });
        }
      }
    } catch (e) {
      console.error('Error reading Swym wishlist:', e);
    }
    
    unloadedButtons.forEach(button => {
      const productId = button.getAttribute('data-product-id');
      const variantId = button.getAttribute('data-variant-id');
      const productUrl = button.getAttribute('data-product-url');
      
      button.classList.add('swym-loaded');
      
      if (wishlistProductIds.has(productId)) {
        button.classList.add('swym-added');
        button.setAttribute('aria-label', 'Added To Wishlist');
      }
      
      const productData = {
        empi: parseInt(productId, 10),
        epi: parseInt(variantId, 10),
        du: productUrl,
        dt: button.getAttribute('data-product-title') || '',
        iu: button.getAttribute('data-product-image') || '',
        pr: parseInt(button.getAttribute('data-product-price') || '0', 10),
        uri: productUrl,
        vi: button.getAttribute('data-product-image') || '',
        _fv: true,
        _cv: true
      };
      
      button.onclick = function(e) {
        e.preventDefault();
        const isAdded = this.classList.contains('swym-added');
        
        if (isAdded) {
          window._swat.removeFromWishList(productData, () => {
            button.classList.remove('swym-added');
            button.setAttribute('aria-label', 'Add to Wishlist');
          });
        } else {
          window._swat.addToWishList(productData, () => {
            button.classList.add('swym-added');
            button.setAttribute('aria-label', 'Added To Wishlist');
          }, () => {
            button.classList.remove('swym-added');
          });
        }
      };
    });
  }

  function startSwymObserver() {
    const swymObserver = new MutationObserver(mutations => {
      let hasNewSwymButtons = false;
      
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              if ((node.classList && node.classList.contains('swym-button')) ||
                  (node.querySelectorAll && node.querySelectorAll('.swym-button').length > 0)) {
                hasNewSwymButtons = true;
              }
            }
          });
        }
      });
      
      if (hasNewSwymButtons) {
        clearTimeout(window.swymReinitTimeout);
        window.swymReinitTimeout = setTimeout(reinitializeSwymForNosto, 500);
      }
    });

    swymObserver.observe(document.body, { childList: true, subtree: true });
  }

  function initSwymNostoIntegration() {
    if (document.body && window._swat) {
      startSwymObserver();
    } else {
      setTimeout(initSwymNostoIntegration, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSwymNostoIntegration);
  } else {
    initSwymNostoIntegration();
  }
})();